import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchFuelPrices,
  type FuelPricesDoc,
} from '../repositories/fuelPrices.js';

/**
 * F-02: `fuel_prices/{tenantId}` の React Query hook。
 *
 * cache key: `['fuelPrices', tenantId]`
 * - tenantId が null/undefined の間は disabled
 * - F-03 の Callable から `queryClient.invalidateQueries({ queryKey: ['fuelPrices'] })` で再取得
 */
export function useFuelPrices(
  tenantId: string | null | undefined,
): UseQueryResult<FuelPricesDoc | null, Error> {
  return useQuery({
    queryKey: ['fuelPrices', tenantId],
    queryFn: () => fetchFuelPrices(tenantId as string),
    enabled: !!tenantId,
    staleTime: 30 * 1000,
  });
}
